export const LocalSaveStates = {
	SAVED_STATS: 'SAVED_STATS',
	HAS_PIN_SET: 'HAS_PIN_SET',
	WANT_OTP: 'WANT_OTP',
	MESSAGE_CONFIRM_DATA: 'MESSAGE_CONFIRM_DATA',
};
